import { provideRouter, RouterConfig } from '@angular/router';

import { WelcomeComponent } from './home/welcome.component';
import { AirportRoutes } from './airports/airport.routes';
import { SystemManagementRoutes } from './system-management/system-management.routes';
import { ScenarioActivitiesRoutes } from './scenario-activities/scenario-activities.routes';
import { QueryReportRoutes } from './query-reports/query-report.routes';

import { AuthRoutes } from './authentication/auth.routes';
import { AdminRoutes } from './administration/admin.routes';
import { AccountRoutes } from './accounts/account.routes';
import { AuthGuard } from './authentication/auth-guard.service';
import { AuthService } from './authentication/auth.service';
//import { Http } from '@angular/http';

export const routes: RouterConfig = [
  { path: '', redirectTo: '/welcome', pathMatch: 'full'},
  { path: 'welcome', component: WelcomeComponent, canActivate: [AuthGuard] },
  ...AirportRoutes,
  ...SystemManagementRoutes,
  ...ScenarioActivitiesRoutes,
  ...QueryReportRoutes,
  ...AuthRoutes,
  ...AdminRoutes,
  ...AccountRoutes
];

export const APP_ROUTER_PROVIDERS  = [
  provideRouter(routes), AuthGuard, AuthService//, Http
];



/** WEBPACK FOOTER **
 ** ./app/app.routes.ts
 **/